import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tk6ffkngnw: FaireBrandEntity = {
  token: "b_tk6ffkngnw",
  type: "brand",
  name: "PureYou Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/9c8801e5773e2f65cd8e07f9a2e0832786f0b86a5fbaee1c160f9b6dc43d4316.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/215b643b3636c9dec299c51e5d2149e66225b4f54335a9ddbbe65a44da222e75.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9c8801e5773e2f65cd8e07f9a2e0832786f0b86a5fbaee1c160f9b6dc43d4316.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/215b643b3636c9dec299c51e5d2149e66225b4f54335a9ddbbe65a44da222e75.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 3.4,
  reviewCount: 10,
  isInsider: true,
  description:
    "At Pure You, we believe jewelry should be as unique as the person who wears it. That’s why we bring together fine craftsmanship, ethical sourcing, and full creative freedom, letting every retailer design collections that reflect their own identity.\n\nWith no minimum order quantity, you can start small, dream big, and scale seamlessly. Every piece is fully customizable from gold color and diamond type (natural or lab-grown) to engraving and packaging that is backed by transparent pricing and fast, reliable worldwide shipping.\n\nOur mission is simple: to make premium fine jewelry accessible without compromise. Whether you’re building a new collection or restocking your bestsellers, Pure You Jewelry delivers the quality, trust, and flexibility your business deserves.\n\n✨ No MOQ. Full customization. Honest pricing. Exceptional quality. Always PureYou.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.322Z",
    importedBy: "entity-db-cli",
  },
};
